import React from "react";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <Paper elevation={0} sx={{ p: 4, borderRadius: 4, border: "1px solid rgba(118, 93, 68, 0.12)", background: "rgba(255, 250, 244, 0.94)" }}>
      <Stack spacing={2}>
        <Typography variant="h4" sx={{ fontWeight: 800 }}>
          Admin page not found
        </Typography>
        <Typography sx={{ color: "text.secondary" }}>
          The requested admin route does not exist.
        </Typography>
        <Button component={RouterLink} to="/admin/dashboard" variant="contained" sx={{ alignSelf: "flex-start" }}>
          Go to dashboard
        </Button>
      </Stack>
    </Paper>
  );
}
